import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';

import { IPunchDTO } from 'src/api/dtos';
import { IError } from 'src/api/types';

import { createPunch, fetchRecentPunches } from './punches.actions';
import { IPunchState } from './punches.types';

const initialState: IPunchState = {
  data: [],
  loading: false,
  submitting: false,
  error: null,
};

export const punchesSlice = createSlice({
  name: 'punch',
  initialState,
  reducers: {
    reset: (state: Draft<IPunchState>) => {
      return { ...initialState, data: state.data };
    },
  },
  extraReducers: (build) => {
    /* fetchRecentPunches */
    build.addCase(
      fetchRecentPunches.fulfilled.type,
      (state: Draft<IPunchState>, { payload }: PayloadAction<IPunchDTO[]>) => {
        return {
          ...state,
          data: payload,
          loading: false,
        };
      },
    );
    build.addCase(fetchRecentPunches.pending.type, (state: Draft<IPunchState>) => {
      return {
        ...state,
        error: null,
        loading: true,
      };
    });
    build.addCase(fetchRecentPunches.rejected.type, (state: Draft<IPunchState>, { payload }: PayloadAction<IError>) => {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    });
    /* createPunch */
    build.addCase(createPunch.fulfilled.type, (state: Draft<IPunchState>, { payload }: PayloadAction<IPunchDTO>) => {
      state.data.push(payload);
      state.submitting = false;
    });
    build.addCase(createPunch.pending.type, (state: Draft<IPunchState>) => {
      return {
        ...state,
        error: null,
        submitting: true,
      };
    });
    build.addCase(createPunch.rejected.type, (state: Draft<IPunchState>, { payload }: PayloadAction<IError>) => {
      return {
        ...state,
        error: payload,
        submitting: false,
      };
    });
  },
});

const { actions } = punchesSlice;

export const { reset: resetPunchActionCreator } = actions;
